<template>
<div>
  <div id="customer-profile-details" class="vx-row">
    <vx-card title="BRANDING">
      <div class="flex flex-wrap items-center mb-base">
        <img :src="avatar" width="300" class="mr-4 mb-4" />
        <div>
          <vs-button @click="toggleShow" class="mr-4 sm:mb-0 mb-2">Upload company logo</vs-button>
          <p class="text-sm mt-2">Allowed JPG or PNG.</p>
        </div>
        <my-upload field="img"
                   @crop-success="cropSuccess"
                   v-model="show"
                   lang-type="en"
                   :params="params"
                   :headers="headers"
                   img-format="png"></my-upload>
      </div>
    </vx-card>
  </div>
</div>
</template>

<script>
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import SettingRepository from "@/repository/SettingRepository";
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import Cookies from "js-cookie";

const settingsRepository =  RepositoryFactory.get('settings')
const FileRepository = RepositoryFactory.get('file')

export default {
  name: "Branding",
  data () {
    return {
      avatar:'',
      show:false,
      params: {
        token: Cookies.get('current_user_token'),
        name: 'avatar'
      },
      headers: {
        authorization: 'Bearer ' + Cookies.get('current_user_token'),
      },
      tenantId:'',
    }
  },
  async mounted() {
    this.tenantId = this.$route.params.id
    await this.fetchSettings()
  },
  components:{
    'my-upload': myUpload
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async fetchSettings() {
      this.$vs.loading();
      const {data} = (await settingsRepository.getSettingsList(this.tenantId)).data
      this.avatar = data.company_logo.elements[0].value
      this.$vs.loading.close()
    },
    async cropSuccess(imgDataUrl, field){
      this.$vs.loading();
      try {
        const base_64 = imgDataUrl.split(",")[1]
        const { data } = await FileRepository.uploadBase64File({
          file_name: Date.now() + '',
          path: 'company/logo',
          file: base_64 + '',
          extension: 'png'
        })

        await SettingRepository.updateTenantCompanyLogo(this.tenantId, { company_logo: data.data.file })
        // this.createForm.company_logo = data.data.file
        this.avatar = imgDataUrl
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
  }
}
</script>

<style scoped>

</style>
